import { ContentBody } from 'components/pages/components/ContentBody'
import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RoutePaths } from 'routes/paths'

const KnowledgeHub: FC = () => {
  const { t } = useTranslation()

  return <ContentBody title={t('knowledgeHub.sustamize')}></ContentBody>
}

const exportObj = {
  routeProps: {
    // This gets passed straight to react-router
    path: RoutePaths.knowledgeHub,
    title: 'knowledgeHub.sustamize',
    element: <KnowledgeHub />,
    roles: componentPermissions[componentNames.pageHelpKnowledgeHub],
    requiresAuthentication: true,
  },
  name: 'KnowledgeHub',
}
export default exportObj
